import { Box, Button, Divider, Flex, Grid, GridItem, Heading, Icon, Image, Link, Table, Tbody, Td, Text, Tr, useMediaQuery } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { MdOutlineViewList, MdOutlineViewModule } from 'react-icons/md';
import { useQuery } from 'react-query';
import { theme } from '../../../assets/style/theme';
import { getPostList } from '../../../service';

type Props = {
};

function ParticipationContentItemSheforum({  }: Props) {

  const [viewMode, setViewMode] = useState('list' as 'list' | 'table');

  const { isLoading, error, data } = useQuery(['ParticipationContentItemSheforum'], () => getPostList('sheforum_lib', undefined, undefined, 12));

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const tableStyle = {
    borderTopWidth: '3px',
    borderStyle: 'solid',
    borderTopColor: 'b.dgr',
  }

  const tdStyle = {
    borderBottomWidth: '1px',
    borderStyle: 'solid',
    borderBottomColor: 'b.g',
    pt: isMobile ? '4' : '8',
    pb: isMobile ? '4' : '8',
    pl: '0',
    pr: '5',
    fontWeight: '800',
  }

  const boxStyle = {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#e6e6e6',
    width: '282px',
    borderRadius: '24px',
    overflow: 'hidden',
  }

  return (
    <>
    <Divider mt="14" mb="14" color="b.lg" />
    <Flex align="center" justify="start" pb="9">
      <Heading size="4xl" color="b.dgr" >자료실</Heading>
      {
        !isMobile && (
          <Box pl={3} pr={3} mt={1}  >
            <button onClick={() => setViewMode('list')}>
              <Icon as={MdOutlineViewList} w={8} h={8} color={viewMode === 'list' ? 'b.dgr' : 'b.lg'} />
            </button>
            <button onClick={() => setViewMode('table')}>
              <Icon as={MdOutlineViewModule} w={8} h={8}  color={viewMode === 'table' ? 'b.dgr' : 'b.lg'} />
            </button>
          </Box>
        )
      }
    </Flex>
    {
      !isLoading && !error && data && (
        <>
        {
          viewMode === 'list' && (
            <Table variant="simple" size="lg" {...tableStyle}>
              <Tbody>
                {
                  data.map((item:any, index:number) => (
                    <Tr key={index}>
                      <Td w="70%" {...tdStyle} >
                        <Text fontSize={isMobile ? 'xl' : '2xl'} fontWeight="800" w="99%" noOfLines={1} ><Link href={`/board/?mode=view&board_id=sheforum_lib&post_id=${item.id}&reqmode=wp`} dangerouslySetInnerHTML={ {__html: item.title} }></Link></Text>
                      </Td>
                      {
                        !isMobile && (
                          <Td fontSize="2xl" color="b.lg" whiteSpace="nowrap" {...tdStyle} textAlign="right">{dayjs(item.date).format('YYYY. MM. DD')}</Td>
                        )
                      }
                    </Tr>
                  ))
                }
              </Tbody>
            </Table>
          )
        }
        {
          viewMode === 'table' && (
            <Grid templateColumns='repeat(4, 1fr)' gap={6}>                    
              {
                data.map((item:any, index:number) => (
                  <GridItem key={index} w='100%' borderWidth="1px" borderColor="b.lg" borderStyle="solid" >
                    <Link href={`/board/?mode=view&board_id=sheforum_lib&post_id=${item.id}&reqmode=wp`} >
                    {
                      item.featured_medium ? (
                        <Image src={item.featured_medium}  objectFit='cover' w="100%" h={200} />
                      ) : (
                        <Box w="100%" h={200} bg="b.gr"></Box>
                      )
                    }
                    </Link>
                    
                    <Box p={3}>
                      <Link href={`/board/?mode=view&board_id=sheforum_lib&post_id=${item.id}&reqmode=wp`} >                        
                        <Heading size="lg" dangerouslySetInnerHTML={ {__html: item.title} } >
                        </Heading>
                      </Link>
                    </Box>
                  </GridItem>
                ))
              }
            </Grid>
          )
        }
        </>
      )
    }
    </>
  );
}

ParticipationContentItemSheforum.defaultProps = {
};

export default ParticipationContentItemSheforum;
